import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
 // private readonly key: string = 'uKM+t5UQJbF8D/nU3y45HdqktAfZGQc+RZ8Vi83oxGo='; // Must be exactly 32 characters
  private iv = CryptoJS.enc.Utf8.parse('uKM+t5UQJbF8DanU');
  private  keyBase64 = 'uKM+t5UQJbF8D/nU3y45HdqktAfZGQc+RZ8Vi83oxGo=';
  
   // List of allowed property names
   private allowedProperties: Array<string> = [
    'firstname','firstName', 'username', 'middleName','middlename', 'fullname', 'gender_value', 'lastname','lastName','fullName','middlename',
    'emiratesid','emirateID', 'email', 'contact', 'idn', 'age', 'region_value','submittedByFacility_value','icaAddress','icaHomeNumber','icaMobileNumber',
    'facilityMember_value', 'createdby_value', 'modifiedby_value', 'fullarabicname', 'firstNameArabic','patientId_value',"createdBy_value",
    'secondNameArabic', 'thirdNameArabic', 'familyNameArabic', 'fullEnglishName', 'firstNameEnglish',"nationality_value",
    'secondNameEnglish', 'thirdNameEnglish', 'fourthnameenglish', 'familynameenglish', 'clannameenglish',"licenceNumber",
    'phoneNumber', 'details', 'arName', 'enName', 'mothernameen', 'mothernamear', 'familyBookNumber','patientName',"passportNumber",
    'sHA_id', 'arDesc', 'enDesc','healthCareFacilityName_value','facilityMemberRole_value','createdBy_value',"address","homePhone","healthCareFacilityName_value",
    "unifiedNumber","fullnameAR","gender","mobile","lastnameEN","fullnameEN","lastnameAR","idn","nationalityEN","firstnameEN","nationalityAR","firstnameAR",
    "addressFromMalaffi","ageInMonths","ageInYears","cityFromICP_value","cityFromMalaffi_value","emiratesOfResidenceFromMalaffi_value",
    "emiratesOfResidenceFromICP_value","icpAddress","icpContactNumber","icpHomeNumber",
    "mobileNumberFromMalaffi","contactNumberFromMalaffi","dateOfBirth","dateOfBirth_value","medicalRecordNumber","mobilePhone","emiratesOfResidence_value"
  ];
  // Decode the Base64-encoded key and IV to WordArrays
  private key = CryptoJS.enc.Base64.parse(this.keyBase64);
 

  // // Encrypt a plain text
  // encrypt(value: string): string {
  //   const keyBytes = CryptoJS.enc.Utf8.parse(this.key);
  //   const iv = CryptoJS.lib.WordArray.random(16);
  //   const encrypted = CryptoJS.AES.encrypt(value, keyBytes, { iv });
  //   return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
  // }

  decrypt(text: string,key:string): string {
    try {
      if(text==""){
        return text;
    
        }
        const decrypted = CryptoJS.AES.decrypt(text, this.key, {
          keySize: 128 / 8,
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
    
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return text
    }

  }
  encrypt(text: string): string {
    const encrypted = CryptoJS.AES.encrypt(text, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
  
    return encrypted.toString(); // Returns Base64 encoded ciphertext
  }
// Recursive function to decrypt a JSON payload
decryptPayload(payload: any): any {
  if (Array.isArray(payload)) {
    // Decrypt each element in the array
    return payload.map((item) => this.decryptPayload(item));
  } else if (typeof payload === 'object' && payload !== null) {
    // Decrypt each key-value pair in the object
    const decryptedObject: any = {};
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        const value = payload[key];
       
        if (typeof value === 'string') {
          if (key!="" && this.allowedProperties?.map((row:any) => row?.toLowerCase())?.includes(key?.toLowerCase())) {

            // Decrypt string values
            const decryptedValue = this.decrypt(value,key)
            decryptedObject[key] = decryptedValue == "" ? value : decryptedValue;
          }
          else{

            decryptedObject[key] = value;
        }
         
        }
        else if (typeof value === 'object') {
          decryptedObject[key] = this.decryptPayload(value);
        } 
         else {
          // Recursively decrypt nested objects or arrays
          decryptedObject[key] = this.decryptPayload(value);
        }
      
    }
    }
    return decryptedObject;
  }
  // Return other types (numbers, booleans, null) as is
  return payload;
}
// Recursive function to encrypt a JSON payload
encryptPayload(payload: any): any {
  if (Array.isArray(payload)) {
    // Decrypt each element in the array
    return payload.map((item) => this.encryptPayload(item));
  } else if (typeof payload === 'object' && payload !== null) {
    // Decrypt each key-value pair in the object
    const decryptedObject: any = {};
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        const value = payload[key];
       
        if (typeof value === 'string') {
          if (key!="" && this.allowedProperties?.map((row:any) => row?.toLowerCase())?.includes(key?.toLowerCase())) {

            // Decrypt string values
            decryptedObject[key] = this.encrypt(value);
          }
          else{

            decryptedObject[key] = value;
        }
         
        }
        else if (typeof value === 'object') {
          decryptedObject[key] = this.encryptPayload(value);
        } 
         else {
          // Recursively decrypt nested objects or arrays
          decryptedObject[key] = this.encryptPayload(value);
        }
      
    }
    }
    return decryptedObject;
  }
  // Return other types (numbers, booleans, null) as is
  return payload;
}

decryptUP(encryptedText: string): string {
  try {
    const keyUtf8 = CryptoJS.enc.Utf8.parse("a");
    const iv = CryptoJS.enc.Utf8.parse('\0'.repeat(16)); // 16 null bytes like C#

    const decrypted = CryptoJS.AES.decrypt(encryptedText, keyUtf8, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const result = decrypted.toString(CryptoJS.enc.Utf8);
    return result || encryptedText;
  } catch (e) {
    return encryptedText;
  }
}
}
